import { CloudImage, Container, Text } from "@fluidattacks/design";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import type { GetVulnAdditionalInfoQuery } from "gql/graphql";

interface IDependencyProps {
  advisories: Readonly<
    GetVulnAdditionalInfoQuery["vulnerability"]["advisories"]
  >;
}

const DependencyName = ({
  advisories,
}: IDependencyProps): React.JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (_.isNil(advisories)) {
    return (
      <Container>
        <Text
          color={theme.palette.gray[400]}
          fontStyle={"italic"}
          size={"md"}
          wordBreak={"break-word"}
          wordWrap={"normal"}
        >
          {t("searchFindings.tabVuln.notApplicable")}
        </Text>
      </Container>
    );
  }

  return (
    <Container alignItems={"center"} display={"flex"} gap={0.5}>
      <CloudImage
        height={20}
        publicId={`integrates/supply-chain/logo-${advisories.packageManager}`}
        width={20}
      />
      <Text
        color={theme.palette.gray["800"]}
        size={"md"}
        wordBreak={"break-word"}
        wordWrap={"normal"}
      >
        {advisories.package}
      </Text>
    </Container>
  );
};

const formatDependencyName = (
  advisories: Readonly<
    GetVulnAdditionalInfoQuery["vulnerability"]["advisories"]
  >,
): React.JSX.Element => {
  return <DependencyName advisories={advisories} />;
};

export { formatDependencyName };
